
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11195",
                "data-name": "矩形 11195",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.135 0.064)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_236",
        "data-name": "蒙版组 236",
        "class": "cls-2",
        "transform": "translate(0.135 -0.064)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "实物-行李箱",
            "class": "cls-3",
            "d": "M129.944,17.812h1.167v.594a.583.583,0,1,0,1.167,0v-.594h5.444v.594a.583.583,0,1,0,1.167,0v-.594h1.167A1.962,1.962,0,0,0,142,15.833V4.354a1.962,1.962,0,0,0-1.944-1.979H138.5V1.188A1.177,1.177,0,0,0,137.333,0h-4.667A1.177,1.177,0,0,0,131.5,1.188V2.375h-1.556A1.962,1.962,0,0,0,128,4.354V15.833A1.962,1.962,0,0,0,129.944,17.812Zm2.722-16.229a.392.392,0,0,1,.389-.4h3.889a.392.392,0,0,1,.389.4v.792h-4.667Zm-3.5,2.771a.785.785,0,0,1,.778-.792h10.111a.785.785,0,0,1,.778.792V15.833a.785.785,0,0,1-.778.792H129.944a.785.785,0,0,1-.778-.792Zm3.694,10.292a.589.589,0,0,0,.583-.594V6.135a.583.583,0,1,0-1.167,0v7.917A.589.589,0,0,0,132.861,14.646Zm4.278,0a.589.589,0,0,0,.583-.594V6.135a.583.583,0,1,0-1.167,0v7.917A.589.589,0,0,0,137.139,14.646Z",
            "transform": "translate(-123.136 3.065)"
          }
        }
      ]
    }
  ]
})
    }
  